import React from 'react';
import { Button, Tooltip, Modal } from 'antd';
import { withRouter } from 'react-router-dom';
import combineConnectors from '../../../util/combineConnectors';
import { connectToCollaborativeList } from '../../../CollaborativeLists/containers/CollaborativeListDataStore';

const confirm = Modal.confirm;

export class RemoveTitleFromList extends React.Component {
	render() {
		return (
			<Tooltip title="Remove Title from List">
				<Button shape="circle" onClick={this.removeFromList}>
					<div className="icon-notes-cancel archive-request" />
				</Button>
			</Tooltip>
		);
	}

	removeFromList = () => {
		const _this = this;
		const { sku } = this.props;
		confirm({
			title: 'Are you sure you want to remove this title from the list?',
			onOk() {
				_this.props.collaborativeListDataStore.removeTitle(
						sku
					);
			},
			onCancel() {
				console.log('Cancel');
			},
		});
	};
}

const connectors = [withRouter, connectToCollaborativeList];

export default combineConnectors(connectors)(RemoveTitleFromList);
